import CloseIcon from '@material-ui/icons/Close';
import {
  Grid, 
  LinearProgress,
  IconButton 
} from '@material-ui/core';

export default function LoadingData({
  searching,
  onClick,
  classes,
  label,
  hiddenIcon
}) {

  return (
    <div >
      <span hidden={!searching}>{label}</span>
      <Grid container
        hidden={!searching}
        className={classes}
      >
        <Grid item xs={2} style={{position:'absolute'}} hidden={hiddenIcon ? hiddenIcon : false}>
          <IconButton color="primary" aria-label="upload picture" component="button" onClick={onClick}>
            <CloseIcon fontSize='large' style={{width:'1.5rem', height:'1.5rem', marginTop:'-0.25rem'}}/>
          </IconButton>
        </Grid>
        <Grid item xs={12} style={{marginLeft: hiddenIcon ? 0 : '2.5rem', marginTop:'1rem'}}>
          <LinearProgress />
        </Grid>
      </Grid>
    </div>
  )
}